import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getDeliverySettings, updateDeliverySettings } from './actionCreators';
import { SLICE_NAME, IDeliverySettingsState, initialState } from './models';

export const deliverySettingsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeliverySettings.fulfilled, (state: IDeliverySettingsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.settings = payload;
      })
      .addCase(updateDeliverySettings.fulfilled, (state: IDeliverySettingsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        if (state?.settings) state.settings = { ...state.settings, ...payload };
      })
      .addMatcher(isPending(getDeliverySettings, updateDeliverySettings), (state: IDeliverySettingsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getDeliverySettings, updateDeliverySettings), (state: IDeliverySettingsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
